import { gql } from "@apollo/client";

const GET_PROGRAMS = gql`
  query GetPrograms(
    $currency: String
    $filter: [String!]
    $language: String
    $studyLanguageId: ID
  ) {
    plans(
      currency: $currency
      filter: $filter
      language: $language
      studyLanguageId: $studyLanguageId
    ) {
      id
      name
      costCategory
      price
      packageDuration
      credits
      currency
      filter
      type
    }
  }
`;

export default GET_PROGRAMS;
